
// window.LANG = "ru"; // just a test
export default {
  'oz': 'fr',
  'uz': 'en',
  'ru': 'ru'
};



// WEBPACK FOOTER //
// ./src/lib/langs.js